import { FaFacebookMessenger } from "react-icons/fa";

export default function MessengerChat() {
  const openMessenger = () => {
    window.open("https://m.me/105369105154018", "_blank");
  };
  return (
    <button
      onClick={openMessenger}
      className="relative bg-[#DF0088]/90 backdrop-blur-md text-white rounded-full w-16 h-16 flex items-center justify-center shadow-2xl hover:scale-110 transition-all"
    >
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#DF0088]/40 opacity-60"></span>
      <FaFacebookMessenger className="relative z-10" size={40} />
    </button>
  );
}
